<template>
  <div
    class="document"
    :class="{ 'missing-document': document.isMissingFile }"
    v-on:click="!document.isMissingFile && $emit('download', document)">
    <template v-if="document.isMissingFile">
      <div class="warning-container">
        <div class="warning-header">
          <div class="warning-icon">
            <BackstageIcon :name="Icons.TRIANGLE_WARNING" class="white-icon" />
          </div>
          <span class="missing-document-title">
            {{ getOrderDocumentDownloadButtonText(document, $t, userLocale) }}
          </span>
        </div>
        <div class="missing-document-content">
          <div class="missing-document-message">{{ $t('viewOrders.missingDocument') }}</div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="document-container">
        <button
          class="button download-button"
          :class="[{ submitting: document.loading }]"
          :disabled="document.loading"></button>
        <span>
          {{ getOrderDocumentDownloadButtonText(document, $t, userLocale) }}
        </span>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { ordersMixins } from '@/mixins/orders.mixins';
import { Icons } from '@/models/icons.enum';
import { OrderDocument } from '@/models/order-document.model';
import BackstageIcon from '../common/BackstageIcon.vue';

export interface Props {
  document: OrderDocument;
  userLocale: string;
}

defineProps<Props>();
defineEmits<{
  download: [document: OrderDocument];
}>();

const { getOrderDocumentDownloadButtonText } = ordersMixins;
</script>

<style scoped lang="scss">
.document {
  display: flex;
  position: relative;
  transition: background-color 250ms ease;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  margin-bottom: 10px;
  justify-content: flex-start;
  align-items: flex-start;

  .form.fixed .fields .field & span {
    line-height: normal;
    text-align: left;
  }

  &.missing-document {
    cursor: default;
    display: flex;
    align-items: flex-start;

    .warning-container {
      display: flex;
      flex-direction: column;

      .warning-header {
        display: flex;
        align-items: center;
        margin-bottom: 4px;

        .missing-document-title {
          font-weight: 400;
          line-height: 150%;
          font-size: 16px;
        }
      }
    }

    .warning-icon {
      font-size: 20px;
      gap: 10px;
      margin-right: 8px;
      line-height: 1;
    }

    .missing-document-content {
      .missing-document-message {
        font-size: 12px;
        color: var(--dark-gray-color);
        text-align: left;
      }
    }
  }
}

.document-container {
  display: flex;
  align-items: center;

  .download-button {
    padding: 0;
    height: 22px !important;
    min-width: auto;
    width: 22px !important;
    margin-right: 10px;
    margin-top: 2px;
  }

  .button.download-button.submitting {
    width: 22px !important;
    height: 22px !important;
    background-position: 50% center;
    padding: 0 12px;
    margin: -2px 8px 0 0;
  }
}
</style>
